import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';

/**
 * This service should only be used if you need to get access to the currently
 * activated route inside of non-component classes.
 *
 * If you need access to the currently activated route inside of components,
 * just inject ActivatedRoute instead.
 */
@Injectable({
  providedIn: 'root'
})
export class ActivatedRouteService {
  constructor(private router: Router) {}

  getActivatedRouteSnapshots(): ActivatedRouteSnapshot[] {
    return this.getActivatedRoutes().map((route) => route.snapshot);
  }

  getActivatedRoutes(): ActivatedRoute[] {
    let currentRoute: ActivatedRoute = this.router.routerState.root;

    const routes = [currentRoute];

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      routes.push(currentRoute);
    }

    return routes;
  }

  getRouteParam(key: string): string {
    return (
      this.getActivatedRouteSnapshots()
        .map((routeSnapshot) => routeSnapshot.paramMap.get(key))
        .find((param) => param != null) || null
    );
  }
}
